import React from 'react'
import { Row, Col, Form, Input, Button } from "antd";
import Img from "../../image/contact/form.png";
import CustomFormItem from './Fields';
const Forms = () => {
    const [form] = Form.useForm()
  return (
    <section  className="extra-effort py-[80px] px-[1rem]">
      <div className="container m-auto">
        <Row
          gutter={[24, 24]}
          align="middle"
          justify="space-between"
          className="overflow-hidden"
        >
          {/* Left: Image */}

          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div  className="banner-text">
                <h4 className="font-outfit text-sm  md:text-base text-[#555]">
               Contact
               </h4> 
              <h2 className="text-[40px] lg:text-[60px] font-cinzel text-start">
                Send Us a Message
              </h2>
              <p className="pb-5 text-[18px] text-[#000] text-start font-outfit mt-4">
                Use the form below to contact the Lightweave Beacon Legacy team. We aim to respond within a reasonable timeframe while ensuring each inquiry receives thoughtful attention.
              </p>
            
<Form form={form} layout="vertical">
  <Row gutter={16}>
    <Col xs={24} sm={24} md={12}>
      <CustomFormItem
    label="First Name"
    name="fName"
    placeholder="Enter Your First Name Here..."
    // rules={[{ required: true, message: "Please enter your first name" }]}
  />
    </Col>
    <Col xs={24} sm={24} md={12}>
      <CustomFormItem
        label="Last Name"
        name="lName"
       placeholder="Enter Your Last Name Here..."
      />
    </Col>
  </Row>

  <Row gutter={16}>
    <Col xs={24} sm={24} md={12}>
    <CustomFormItem
        label="Email Address"
        name="email"
       placeholder="Enter Your Email Address Here..."
      />
    </Col>
    <Col xs={24} sm={24} md={12}>
     <CustomFormItem
        label="Phone Number"
        name="mobile_number"
       placeholder="Enter Your Phone Number Here..."
      />
    </Col>
  </Row>
   <Form.Item name={'message'} 
   label={<span className="text-black font-cinzel text-[18px]">
    Message
   </span>}
   className='font-cinzel text-[40px]'>
      <Input.TextArea placeholder='Enter Your Message Here...'  rows={8}
       className="border border-gray-300 rounded-lg p-3 text-base 
                   focus:border-blue-500 focus:ring-1 focus:ring-blue-500 
                   transition-all duration-300"
      />
    </Form.Item>
    <Form.Item label={null}>
  <Button
  htmlType="submit"
  type="default" // important! removes AntD primary styling
  className="mt-[20px] text-black font-outfit font-semibold px-6 py-3 rounded-full 
             shadow-md transition-all duration-500 hover:-translate-y-1 hover:shadow-lg"
  style={{
    background:
      "linear-gradient(29deg, rgba(0,240,251,1) 0%, rgba(255,255,255,1) 50%, rgba(0,240,251,1) 100%)",
    backgroundSize: "200% 200%",
    border: "none", // remove AntD border
    color: "black",  // text color
    transition: "all 0.6s ease",
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundPosition = "right center";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundPosition = "left center";
  }}
>
 Send Message
</Button>

</Form.Item>

</Form>

             
            </div>
             {/* Right: Text */}
          </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div  className="mission-images">
              <img
                src={Img}
                className="w-[100%] lg:w-[80%] h-[90%] object-contain rounded-lg "
                alt="img"
              />
            </div>
          </Col>

         
        </Row>
      </div>
    </section>
  )
}

export default Forms
